import { useState } from "react";
import { BASE_URL } from "../../../utility/BaseUrl";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";

export default function GalleryProduct({ product }) {
  const { product_cover, product_cover_alt, product_cover_title, galleries } =
    product;

  const [firstCoverProductUrl, setFirstCoverProductUrl] = useState("");

  const ChangeCoverProductDetails = (event) => {
    setFirstCoverProductUrl(event.target.src);
  };
  return (
    <div className="position-relative">
      {/* expiration */}
      <div className="product-image position-relative">
        {/* actions */}
        <div className="product-actions">
          {/* <button
            type="button"
            className="btn product-addtowishlist"
            onclick="alert('این امکان فقط برای کاربران در دسترس است.')"
          >
            <i className="fa fa-fw fa-heart-o" />
          </button>
          <a
            href="/site/products/compare/add?id=169503381"
            className="btn product-compare"
            data-toggle="tooltip"
            title="مقایسه"
          >
            <i className="fa fa-fw fa-balance-scale" />
          </a> */}
        </div>
        {/* <a
            href="/uploads/products/39b0cd.jpg"
            className="product-image-link"
          > */}
        <img
          src={
            firstCoverProductUrl
              ? firstCoverProductUrl
              : BASE_URL + product_cover
          }
          alt={product_cover_alt}
          title={product_cover_title}
          className="product-image-element"
        />
        {/* </a> */}
      </div>

      <Swiper
        className="product-images"
        navigation={{
          prevEl: ".product-images-prev",
          nextEl: ".product-images-next",
        }}
        breakpoints={{
          992: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        }}
        loop={false}
        spaceBetween={15}
      >
        <SwiperSlide>
          <img
            src={BASE_URL + product_cover}
            alt={product_cover_alt}
            title={product_cover_title}
            className="product-images-item"
            onClick={ChangeCoverProductDetails}
          />
        </SwiperSlide>

        {galleries
          ? galleries.map((item, index) => {
              const { image, image_alt, image_title } = item;
              return (
                <SwiperSlide key={index}>
                  <img
                    src={BASE_URL + image}
                    className="product-images-item"
                    title={image_title}
                    alt={image_alt}
                    onClick={ChangeCoverProductDetails}
                  />
                </SwiperSlide>
              );
            })
          : null}
      </Swiper>
    </div>
  );
}
